import { AxiosError } from 'axios';

export type DetailedAlert = {
    message: string,
    apiResponseCode?: number,
    apiMessage?: string,
    url?: string,
    data?: string
}

export const createDetailedAlert = (error: AxiosError, message: string) => {
    return {
        message: message,
        apiResponseCode: error.response?.status,
        apiMessage: error.message,
        url: error.config?.url,
        data: error.response?.data
    } as DetailedAlert
}

export const formatAlertBodyLines = (alert: DetailedAlert): string[] => {
    const data = alert.data as any;
    if (data === undefined || data === null) {
        return [];
    }
    if (typeof data === 'string') {
        return [data];
    }
    if (typeof data === 'object') {
        if (data.errors && typeof data.errors === 'object') {
            return Object.entries(data.errors).flatMap(([field, messages]) =>
                (Array.isArray(messages) ? messages : [messages]).map((m) => `${field}: ${m}`)
            );
        }
        const summary = data.title ?? data.detail ?? data.Message ?? data.message;
        if (typeof summary === 'string') {
            return [summary];
        }
        return [JSON.stringify(data)];
    }
    return [String(data)];
}